import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './pages/HomePage.vue'
import ContactPage from './pages/ContactPage.vue'
import PrivacyPage from './pages/PrivacyPage.vue'
import NotFoundPage from './pages/NotFoundPage.vue'
import { useLocale } from './composables/useLocale'

const localeRoutes = [
  { path: '', name: 'home', component: HomePage },
  { path: 'contact', name: 'contact', component: ContactPage },
  { path: 'privacy', name: 'privacy', component: PrivacyPage },
]

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      children: localeRoutes,
    },
    {
      path: '/en',
      children: localeRoutes.map(r => ({ ...r, name: r.name ? `${r.name}-en` : undefined })),
    },
    { path: '/:pathMatch(.*)*', component: NotFoundPage }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    }
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  const { locale } = useLocale()
  const isEnRoute = to.path.startsWith('/en')

  if (isEnRoute) {
    locale.value = 'en'
    document.documentElement.lang = 'en'
  } else {
    locale.value = 'nl'
    document.documentElement.lang = 'nl'
  }
})

const saved = typeof localStorage !== 'undefined' && localStorage.getItem('mr-lang')
if (!saved && typeof navigator !== 'undefined' && navigator.language?.startsWith('en')) {
  router.isReady().then(() => {
    if (router.currentRoute.value.path === '/') {
      router.replace('/en')
    }
  })
}

export default router
